import { createSlice } from "@reduxjs/toolkit";
import {
  addPost,
  editPost,
  getPost,
  getPostList,
} from "../services/post-services";

const initialState = {
  posts: [],
  post: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPostList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPostList.fulfilled, (state, action) => {
        state.posts = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getPostList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getPost.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPost.fulfilled, (state, action) => {
        state.posts = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getPost.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addPost.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(addPost.fulfilled, (state, action) => {
        state.posts = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addPost.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editPost.pending, (state, action) => {
        state.loading = false;
      })
      .addCase(editPost.fulfilled, (state, action) => {
        state.posts = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editPost.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      });
  },
});
export const { resetSuccess, resetState, resetError } = postSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default postSlice.reducer;
